import { useEffect, useRef, useState } from "react";
import credentials from "../assets/credentials";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faPause, faSpinner } from "@fortawesome/free-solid-svg-icons";

const useAudio = (url) => {
  const audioRef = useRef(null);
  const [playStatus, setPlayStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // New loading state

  useEffect(() => {
    if (!audioRef.current) {
      audioRef.current = new Audio(`${credentials.musicStream_URL}/${url}`);
      audioRef.current.preload = "auto";

      // Handle loading state when audio starts buffering
      audioRef.current.onwaiting = () => setIsLoading(true);
      audioRef.current.onplaying = () => setIsLoading(false);
    }

    return () => {
      audioRef.current?.pause();
      audioRef.current = null;
    };
  }, [url]);

  const play = () => {
    if (playStatus) {
      pause();
      setPlayStatus(false);
      return;
    }

    if (audioRef.current) {
      setIsLoading(true); // Show loading spinner
      audioRef.current
        .play()
        .then(() => {
          setPlayStatus(true);
          setIsLoading(false); // Hide loading spinner when playing
        })
        .catch((err) => {
          console.error("Audio play failed:", err);
          setIsLoading(false); // Hide loading spinner on error
        });
    }
  };

  const pause = () => {
    audioRef.current?.pause();
    setPlayStatus(false);
  };

  return { play, playStatus, isLoading };
};

const AudioPlayer = ({ url }) => {
  const { play, playStatus, isLoading } = useAudio(url);

  return (
    <div className="absolute grid place-items-center w-full h-full bg-black/30">
      <FontAwesomeIcon
        icon={isLoading ? faSpinner : playStatus ? faPause : faPlay}
        spin={isLoading} // Enables spinning effect on faSpinner
        onClick={play}
        className="text-white text-6xl hover:text-yellow-400 cursor-pointer"
      />
    </div>
  );
};

export default AudioPlayer;